// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Rl2N","question":"styles_question__2--6P","inputVisibleButton":"styles_inputVisibleButton__1Z0-S","note":"styles_note__HIXeW"};